import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { employeesAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { Pencil, Trash2 } from 'lucide-react';
import PrintButton from '../../utils/print';
import PrintLetterhead from '../common/PrintLetterhead';
import { fmtMoney0 } from '../../utils/currency';

const fmt = fmtMoney0;

export default function Employees() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const listRef = useRef(null);

  const load = () => {
    employeesAPI.list().then(setRows).catch(e => toast.error(e.message)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const filtered = rows.filter(r => {
    const q = search.toLowerCase();
    if (!q) return true;
    return [r.first_name, r.last_name, r.email, r.job_title, r.department].some(v => (v || '').toLowerCase().includes(q));
  });

  const doDelete = async (row) => {
    if (!window.confirm(`Delete employee ${row.first_name} ${row.last_name}?`)) return;
    try {
      await employeesAPI.remove(row.id);
      toast.success('Employee deleted');
      load();
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div>
      <div className="toolbar">
        <h2>👥 Employees</h2>
        <div className="toolbar-right">
          <input className="form-control" placeholder="Search employees..." value={search} onChange={e => setSearch(e.target.value)} style={{ width: 250 }} />
          <PrintButton targetRef={listRef} title={`Employees - ${new Date().toLocaleDateString()}`} />
          <button className="btn btn-outline" onClick={() => navigate('/payslip')}>💰 Payslip</button>
          <button className="btn btn-primary" onClick={() => navigate('/employees/new')}>+ New Employee</button>
        </div>
      </div>

      {loading ? <div className="spinner" style={{ margin: '40px auto' }} /> : (
        <div className="card" ref={listRef}>
          <div className="card-body" style={{ padding: 0 }}>
            <PrintLetterhead />
            <table>
              <thead>
                <tr><th>ID</th><th>Name</th><th>Job Title</th><th>Department</th><th>Email</th><th className="text-right">Salary</th><th>Pay Freq.</th><th>Status</th><th className="text-right">Actions</th></tr>
              </thead>
              <tbody>
                {filtered.map(row => (
                  <tr key={row.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/employees/${row.id}/edit`)}>
                    <td className="font-mono">{row.employee_number}</td>
                    <td><strong>{row.first_name} {row.last_name}</strong></td>
                    <td>{row.job_title || '—'}</td>
                    <td>{row.department || '—'}</td>
                    <td className="text-muted">{row.email || '—'}</td>
                    <td className="amount">{fmt(row.salary)}</td>
                    <td>{row.pay_frequency || 'Monthly'}</td>
                    <td>{row.is_active ? <span className="badge badge-posted">Active</span> : <span className="badge badge-voided">Inactive</span>}</td>
                    <td className="text-right" onClick={e => e.stopPropagation()}>
                      <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
                        <button className="btn btn-ghost btn-sm" title="Edit" onClick={() => navigate(`/employees/${row.id}/edit`)}><Pencil size={13} /></button>
                        <button className="btn btn-ghost btn-sm" title="Delete" onClick={() => doDelete(row)}><Trash2 size={13} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={9} className="empty-state"><div className="empty-icon">👥</div><h3>No employees found</h3><p>Add your first employee to get started.</p></td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
